import { useForm } from '@mantine/form';
import { useState } from 'react';
import {
	validateAddressLine,
	validateText,
	validatePostcode,
} from '../../../util/validation/commonValidation';
import type { FullOperatorDto } from '../types/OperatorDto';

export function useAddStaffAddressForm(defaultOperator: FullOperatorDto) {
	const [inputs, setInputs] = useState<FullOperatorDto>(defaultOperator);

	const form = useForm<FullOperatorDto>({
		mode: 'uncontrolled',
		initialValues: defaultOperator,
		validate: {
			postCode: (value) => validatePostcode(value, false),
			town: (value) => validateText(value, false, 'Town'),
			county: (value) => validateText(value, false, 'County'),
			addressLineOne: (value) => validateAddressLine(value, false),
			addressLineTwo: (value) => validateAddressLine(value, true),
		},
		onValuesChange: (v) => setInputs(v),
	});

	return { form, inputs };
}
